import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Briefcase, Radio, Phone, ArrowLeft, ScrollText } from 'lucide-react';
import InvestorSuite from '@/components/InvestorSuite';
import AmbientScribe from '@/components/AmbientScribe';
import ClinicalOutput from '@/components/ClinicalOutput';
import InvestorDocsGate from '@/components/InvestorDocsGate';

// Session 4 (Part A) — dedicated home for tools removed from the main public nav:
// Investor Suite · Ambient Scribe · SMS Provider. Admin/investor access only.
export default function InvestorAccessPage() {
  const [showInvestor, setShowInvestor] = useState(false);
  const [showAmbient, setShowAmbient] = useState(false);
  const [ambientResult, setAmbientResult] = useState(null);

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4" style={{ fontFamily: "'IBM Plex Sans',sans-serif" }}>
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 mb-6" data-testid="investor-access-back">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>

        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Work Sans',sans-serif" }}>Investor &amp; Provider Access</h1>
        <p className="text-sm text-slate-500 mt-1 mb-8">Tools moved off the public navigation. Internal / investor / clinician use.</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          <button onClick={() => setShowInvestor(true)} data-testid="investor-access-investor" className="text-left bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <Briefcase className="w-6 h-6 text-[#1E40AF] mb-2" />
            <div className="font-semibold text-slate-900">Investor Suite</div>
            <div className="text-xs text-slate-500 mt-1">Traction, moats, and the data room.</div>
          </button>

          <button onClick={() => setShowAmbient(true)} data-testid="investor-access-ambient" className="text-left bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <Radio className="w-6 h-6 text-[#EF4444] mb-2" />
            <div className="font-semibold text-slate-900">Ambient Scribe</div>
            <div className="text-xs text-slate-500 mt-1">Record a visit → structured SOAP.</div>
          </button>

          <a href="sms:+19546631720" data-testid="investor-access-sms" className="block bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <Phone className="w-6 h-6 text-emerald-600 mb-2" />
            <div className="font-semibold text-slate-900">SMS Provider</div>
            <div className="text-xs text-slate-500 mt-1">Tap to text your physician.</div>
          </a>
        </div>

        <Link to="/attestation-ledger" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800" data-testid="investor-access-ledger-link">
          <ScrollText className="w-4 h-4" /> Attestation Ledger →
        </Link>

        <div className="mt-10" data-testid="investor-docs-section">
          <h2 className="text-lg font-semibold text-slate-900 mb-1" style={{ fontFamily: "'Work Sans',sans-serif" }}>Document Vault</h2>
          <p className="text-sm text-slate-500 mb-4">Consolidated, server-validated access to all investor, validator, and deep-IP printables.</p>
          <InvestorDocsGate />
        </div>

        {ambientResult && (
          <div className="mt-8">
            <ClinicalOutput result={ambientResult} viewMode="physician" />
          </div>
        )}
      </div>

      <InvestorSuite open={showInvestor} onClose={() => setShowInvestor(false)} />
      <AmbientScribe
        open={showAmbient}
        onClose={() => setShowAmbient(false)}
        onResult={(data) => { setAmbientResult(data); setShowAmbient(false); }}
      />
    </div>
  );
}
